import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import { withTranslation } from 'react-i18next';

import { PolarQuestion } from 'shared/components';
import * as actions from 'core/duck';
import './Demographic.scss';

const defaultQuestions = [
  {
    title: 'profile.background.demographicQuestion',
    subtitleNo: 'profile.background.demographicNotification',
  },
  {
    title: 'profile.background.demographicSecondQuestion',
  },
];

const yesAnswer = 'Yes';

class Demographic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: defaultQuestions,
      user: props.user,
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.isConfirmDisabled = this.isConfirmDisabled.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onRemoveFiles = this.onRemoveFiles.bind(this);
  }

  componentDidMount() {
    this.setState({
      questions: merge(this.state.questions, [
        {
          initial: this.props.user.usCitizenFlag ? 'Yes' : 'No',
          key: 'usCitizenFlag',
        },
        {
          initial: this.props.user.hasI9File ? 'Yes' : 'No',
          key: 'hasI9File',
        },
      ]),
    });
  }

  onAdd(files) {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsString = reader.result;
        const user = { ...this.state.user };
        user.I9File = fileAsString;
        this.setState({
          user,
        });
      };

      reader.readAsDataURL(file);
    });
  }

  handleChange(question, option) {
    const user = { ...this.state.user };
    user[question.key] = option === yesAnswer ? !!option : false;
    this.setState({
      user,
    });
  }

  onRemoveFiles(files) {
    this.setState({
      files,
    });
  }

  isConfirmDisabled() {
    return (
      !this.state.user.usCitizenFlag && (!this.state.user.hasI9File || !this.state.user.I9File)
    );
  }

  handleConfirm() {
    this.props.onConfirm(this.state.user, 1);
  }

  render() {
    const { questions, user } = this.state;
    return (
      <section className="profile-demographic">
        <div className="list-group-item">
          <PolarQuestion className="mb-0" question={questions[0]} onChange={this.handleChange} />
          {!user.usCitizenFlag && (
            <p className="text-strong">{this.props.t('profile.background.demographicMessage')}</p>
          )}
        </div>
        <div className="buttons-container">
          <button type="button" onClick={() => this.props.onBack(1)} className="btn w-50">
            {this.props.t('common.labels.back')}
          </button>
          <button
            type="button"
            className="btn btn-primary w-50 "
            onClick={this.handleConfirm}
            disabled={this.isConfirmDisabled()}>
            {this.props.t('common.labels.continue')}
          </button>
        </div>
      </section>
    );
  }
}

Demographic.propTypes = {
  user: PropTypes.shape({
    usCitizenFlag: PropTypes.bool.isRequired,
    I9File: PropTypes.string,
    hasI9File: PropTypes.bool,
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  if (state.users.currentUser) {
    return {
      user: state.users.currentUser,
    };
  }
  return {
    user: {},
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Demographic));
export { Demographic as PureDemographic }; // for easier unit testing
